import { ResponseDto } from "src/shared/common-dtos/response-dto";
import ApiService from "src/shared/utils/base-api/api-service";
import { CountryDto } from "../../common-dtos/country-dto";

class CountryService extends ApiService {
  constructor() {
    super({
      baseURL: "/Country",
    });
  }

  public getAllCountries(): Promise<ResponseDto<CountryDto[]>> {
    return this.get("/GetAllCountries");
  }

  public getAllCountryStates(input?: any): Promise<ResponseDto<CountryDto[]>> {
    return this.get("/GetAllCountryStates", { params: input });
  }
  public getAllStateCities(input?: any): Promise<ResponseDto<CountryDto[]>> {
    return this.get("/GetAllStateCities", { params: input });
  }
}

export const countryService = new CountryService();
